module.exports = __webpack_public_path__ + "static/media/decorationDownContent.6df10381.png";